import { render, staticRenderFns } from "./ApplicantsInfo.vue?vue&type=template&id=400f741f&scoped=true"
import script from "./ApplicantsInfo.vue?vue&type=script&lang=js"
export * from "./ApplicantsInfo.vue?vue&type=script&lang=js"
import style0 from "./ApplicantsInfo.vue?vue&type=style&index=0&id=400f741f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f741f",
  null
  
)

export default component.exports